import { useEffect, useMemo, useState } from "react";
import { routes } from "../../../app/routes";
import { useUrlParams } from "../../../hooks";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const ProfileTopbar = (props: any) => {

  const returnUrl = useUrlParams("returnUrl");
  const id = useUrlParams("id");

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
      {
        label: "Profile",
        icon: IconDefinitions.user,
        url: routes.profile.index,
        activeMatch: routes.profile.index,
        activeMatchExact: true,
      },
      {
        label: "Change Password",
        icon: IconDefinitions.lock,
        url: routes.profile.changePassword,
        activeMatch: routes.profile.changePassword,
        activeMatchExact: true,
      }
    ],
    [id]
  );

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, id, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems} />;
};

export default ProfileTopbar;

